import BONESMidwayJavaScriptClient from "BONESMidwayJavaScriptClient";

export class JSClient {

  constructor(props) {
    this.props = props || {};
    this.clientLoaded = this.clientLoaded.bind(this);
    this.getTeams = this.getTeams.bind(this);
    this.getIdentity = this.getIdentity.bind(this);
    this.postTeamInfo = this.postTeamInfo.bind(this);
    this.postTeam = this.postTeam.bind(this);
    this.deleteTeamInfo = this.deleteTeamInfo.bind(this);
    this.deleteTeamOncall = this.deleteTeamOncall.bind(this);
    new BONESMidwayJavaScriptClient({ onReady: this.clientLoaded });
  }

  clientLoaded(client) {
    this.client = client;
    if (this.props.hasOwnProperty("onReady")) {
      this.props.onReady();
    }
  }

  getTeams() {
    return this.client.get("teams");
  }

  postTeam(request) {
    return this.client.post("teams", request);
  }

  deleteTeamOncall(request) {
    return this.client.delete(`teams?identityType=${request.identityType}&identity=${request.identity}`);
  }

  postTeamInfo(request) {
    return this.client.post("teaminfos", request);
  }

  deleteTeamInfo(request) {
    return this.client.delete(`teaminfos?identityType=${request.identityType}&identity=${request.identity}`);
  }

  getIdentity() {
    return this.client.get("identity");
  }

  sendPage(request) {
    return this.client.post("page", request);
  }
}



// WEBPACK FOOTER //
// ./src/components/common.jsx